import Oidc from 'oidc-client'

var settings = {
    authority: process.env.VUE_APP_URL_IDENTITY_SERVER,
    client_id: document.location.hostname,
    redirect_uri: document.location.origin + '/signin',
    automaticSilentRenew: false,
    silent_redirect_uri: document.location.origin + '/refresh.html',
    post_logout_redirect_uri: document.location.origin,
    response_type: 'id_token token',
    scope: 'openid profile email roles desk4me_api_read_scope desk4me_api_write_scope freeroom_api_read_scope freeroom_api_write_scope apigwweb apigwauth',
    filterProtocolClaims: true,
    loadUserInfo: true,
    revokeAccessTokenOnSignout: true,
    userStore: new Oidc.WebStorageStateStore(Oidc.Global.localStorage)
}

var userManager = new Oidc.UserManager(settings)

export default userManager
